const loginActionTypes = {
  LOGIN_START_FETCH: 'LOGIN_START_FETCH',
  LOGIN_FIRST_LOGIN: 'LOGIN_FIRST_LOGIN',
  LOGIN_SET_ERROR: 'LOGIN_SET_ERROR',
  LOGIN_REMOVE_ERROR: 'LOGIN_REMOVE_ERROR',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_FAILURE: 'LOGIN_FAILURE',
  REMOVE_POPUP: 'REMOVE_POPUP',
  LOGOUT: 'LOGOUT',
  CLEAR_FIRST_LOGIN: 'CLEAR_FIRST_LOGIN',
};

export default loginActionTypes;
